import { Locale } from 'src/models/dto/Locale'

export const isDefaultLocale = (locale: Locale) => {
    return !locale || locale === Locale.en_US
}
